module.exports = __webpack_public_path__ + "static/media/travel-1303949_640_color.04a83871.png";